import Vue from 'vue'
import VueRouter from 'vue-router'

// import Home from '../views/Home.vue'
import Calendar from '../views/Calendar.vue'
import Login from '../views/Security/Login.vue'
import ForgotPassword from '../views/Security/ForgotPassword.vue'
import Error404 from '../views/Errors/404.vue'

import Users from '../views/Administration/Users.vue'
import UserForm from '../views/Administration/UserForm.vue'

import Customers from '../views/Customers/Customers.vue'
import CustomerForm from '../views/Customers/CustomerForm.vue'
import CustomerDetails from '../views/Customers/CustomerDetails.vue'

import Celebrations from '../views/Celebrations/Celebrations.vue'
import CelebrationForm from '../views/Celebrations/CelebrationForm.vue'
import CelebrationDetails from '../views/Celebrations/CelebrationDetails.vue'

// import Invoices from '../views/Invoices/Invoices'
import InvoiceForm from '../views/Invoices/InvoiceForm.vue'
import InvoiceDetails from '../views/Invoices/InvoiceDetails'

import FundraisingForm from '../views/Fundraisings/FundraisingForm.vue'
import FundraisingDetails from '../views/Fundraisings/FundraisingDetails.vue'
import JoinedForm from '../views/Fundraisings/JoinedForm.vue'
import JoinedMultipleForm from '../views/Fundraisings/JoinedMultipleForm.vue'

import ParticipantDetails from '../views/Participants/ParticipantDetails.vue'

import RenegotiationForm from '../views/Renegotiations/RenegotiationForm.vue'

import Experiences from '../views/Experience/Experiences.vue'
import ExperienceUsers from '../views/Experience/Users.vue'

import TechnicalSupportPanel from '../views/Support/TechnicalSupportPanel.vue'
import TechnicalSupportForm from '../views/Support/TechnicalSupportForm.vue'
import Providers from '../views/Support/Providers.vue'
import InvoiceConsult from '../views/Support/InvoiceConsult.vue'

import AutomationCreateAccount from '../views/Automation/CreateAccount.vue'
import AutomationGenerateFinancial from '../views/Automation/GenerateFinancial.vue'
import AutomationSendWhatsapp from '../views/Automation/SendWhatsapp.vue'
import AutomationSendEmail from '../views/Automation/SendEmail.vue'


import HuggyAnalytics from '../views/HuggyAnalytics.vue'
import Teste from '../views/Teste.vue'

import CelebrationPrint from '../views/Print/CelebrationDetails.vue'
import CelebrationPresentation from '../views/Print/CelebrationPresentation.vue'
import FundraisingPrint from '../views/Print/FundraisingDetails.vue'
import ParticipantPrint from '../views/Print/ParticipantDetails.vue'

import Transfer from '../views/Documents/Transfer.vue'
import Transfer2 from '../views/Documents/Transfer2.vue'
import Withdraw from '../views/Documents/Withdraw.vue'
import FeeCashback from '../views/Documents/FeeCashback.vue'
import TransferCashback from '../views/Documents/TransferCashback.vue'
import HeppiPlan from '../views/Documents/HeppiPlan.vue'
import Devolution from '../views/Documents/Devolution.vue'
import ChargeBack from '../views/Documents/ChargeBack.vue'
import AccountExtract from '../views/Documents/AccountExtract.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Calendar
  },
  // {
  //   path: '/calendario',
  //   name: 'calendar',
  //   component: Calendar
  // },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { noAuth: true, noHeader: true }
  },
  {
    path: '/esqueci-senha',
    name: 'forgotPassword',
    component: ForgotPassword,
    meta: { noAuth: true, noHeader: true }
  },
  {
    path: '/recuperar-senha',
    name: 'resetPassword',
    component: ForgotPassword,
    props: true,
    meta: { noAuth: true, noHeader: true }
  },
  // Administration
  {
    path: '/usuarios',
    name: 'users',
    component: Users,
    meta: { no404Page: true }
  },
  {
    path: '/usuarios/novo',
    name: 'newUser',
    component: UserForm
  },
  // Customers
  {
    path: '/clientes',
    name: 'customers',
    component: Customers,
    meta: { no404Page: true }
  },
  {
    path: '/clientes/editar/:id',
    name: 'customerForm',
    component: CustomerForm,
    props: true
  },
  {
    path: '/clientes/novo',
    name: 'customerFormNew',
    component: CustomerForm,
    props: true
  },
  {
    path: '/clientes/:id',
    name: 'customerDetails',
    component: CustomerDetails,
    props: true
  },
  // Celebrations
  {
    path: '/turmas',
    alias: '/comemoracoes',
    name: 'celebrations',
    component: Celebrations,
    meta: { no404Page: true }
  },
  {
    path: '/turmas/editar/:id',
    alias: '/comemoracoes/editar/:id',
    name: 'celebrationForm',
    component: CelebrationForm,
    props: true
  },
  {
    path: '/turmas/novo',
    alias: '/comemoracoes/novo',
    name: 'celebrationFormNew',
    component: CelebrationForm,
    props: true
  },
  {
    path: '/turmas/:id',
    alias: '/comemoracoes/:id',
    name: 'celebrationDetails',
    component: CelebrationDetails,
    props: true
  },
  // Fundraisings
  {
    path: '/:celebrationId/arrecadacoes/novo',
    name: 'fundraisingForm',
    component: FundraisingForm,
    props: true
  },
  {
    path: '/arrecadacoes/editar/:id',
    name: 'fundraisingFormEdit',
    component: FundraisingForm,
    props: true
  },
  {
    path: '/:celebrationId/arrecadacoes/:id',
    name: 'fundraisingDetails',
    component: FundraisingDetails,
    props: true
  },
  {
    path: '/participantes/:id',
    name: 'participantDetails',
    component: ParticipantDetails,
    props: true
  },
  {
    path: '/turmas/:celebrationId/arrecadacoes/:fundraisingId/entrar-na-arrecadacao',
    alias: '/comemoracoes/:celebrationId/arrecadacoes/:fundraisingId/entrar-na-arrecadacao',
    name: 'newJoined',
    component: JoinedForm,
    props: true
  },
  {
    path: '/turmas/:celebrationId/arrecadacoes/:fundraisingId/adicionar-participantes',
    name: 'newMultipleJoined',
    component: JoinedMultipleForm,
    props: true
  },
  // Invoices
  // {
  //   path: '/faturas',
  //   name: 'invoices',
  //   component: Invoices,
  //   meta: { no404Page: true }
  // },
  {
    path: '/faturas/novo',
    name: 'newInvoice',
    component: InvoiceForm
  },
  {
    path: '/faturas/editar/:id',
    name: 'updateInvoice',
    component: InvoiceForm,
    props: true
  },
  {
    path: '/faturas/:id',
    name: 'invoiceDetails',
    component: InvoiceDetails,
    props: true
  },
  // Renegotiation
  {
    path: '/renegociacao',
    name: 'renegotiationForm',
    component: RenegotiationForm,
    props: true
  },
  // Experience
  {
    path: '/experiencias',
    name: 'experiences',
    component: Experiences,
    props: true
  },
  {
    path: '/experiencia-usuarios',
    name: 'experienceUsers',
    component: ExperienceUsers,
    props: true
  },
  // Support
  {
    path: '/apoio-tecnico',
    name: 'technicalSupportPanel',
    component: TechnicalSupportPanel,
    props: true
  },
  {
    path: '/solicitacao-tecnica/:id',
    name: 'technicalSupportForm',
    component: TechnicalSupportForm,
    props: true
  },
  {
    path: '/fornecedores',
    name: 'providers',
    component: Providers,
    props: true
  },
  {
    path: '/consulta-fatura',
    name: 'invoiceConsult',
    component: InvoiceConsult,
    props: true
  },
  {
    path: '/automacao/enviar-whatsapp',
    name: 'automationSendWhatsapp',
    component: AutomationSendWhatsapp,
    props: true
  },
  {
    path: '/automacao/enviar-email',
    name: 'automationSendEmail',
    component: AutomationSendEmail,
    props: true
  },
  // Automações
  {
    path: '/automacao/habilitar-conta',
    name: 'automationCreateAccount',
    component: AutomationCreateAccount,
    props: true
  },
  {
    path: '/automacao/gerar-financeiro',
    name: 'automationGenerateFinancial',
    component: AutomationGenerateFinancial,
    props: true
  },
  {
    path: '/analytics',
    name: 'huggyAnalytics',
    component: HuggyAnalytics
  },
  {
    path: '/callback',
    redirect: '/analytics'
  },
  {
    path: '/teste',
    name: 'teste',
    component: Teste,
    props: true
  },
  // Impressão
  {
    path: '/relatorio/:celebrationId',
    name: 'celebrationPrint',
    component: CelebrationPrint,
    meta: { noHeader: true },
    props: true
  },
  {
    path: '/apresentacao/:celebrationId',
    name: 'celebrationPresentation',
    component: CelebrationPresentation,
    meta: { noHeader: true },
    props: true
  },
  {
    path: '/relatorio/:celebrationId/arrecadacao/:id',
    name: 'fundraisingPrint',
    component: FundraisingPrint,
    meta: { noHeader: true },
    props: true
  },
  {
    path: '/relatorio/participante/:id',
    name: 'participantPrint',
    component: ParticipantPrint,
    meta: { noHeader: true },
    props: true
  },
  // Documents
  {
    path: '/documentos/transferencia',
    name: 'transfer',
    component: Transfer,
    meta: { noAuth: true, noHeader: true },
    props: true
  },
  {
    path: '/documentos/transferencia2',
    name: 'transfer2',
    component: Transfer2,
    meta: { noAuth: true, noHeader: true },
    props: true
  },
  {
    path: '/documentos/resgate',
    name: 'withdraw',
    component: Withdraw,
    meta: { noAuth: true, noHeader: true },
    props: true
  },
  {
    path: '/documentos/cashback-taxa',
    name: 'feeCashback',
    component: FeeCashback,
    meta: { noAuth: true, noHeader: true },
    props: true
  },
  {
    path: '/documentos/cashback-transferencia',
    name: 'transferCashback',
    component: TransferCashback,
    meta: { noAuth: true, noHeader: true },
    props: true
  },
  {
    path: '/documentos/plano-heppi',
    name: 'heppiPlan',
    component: HeppiPlan,
    meta: { noAuth: true, noHeader: true },
    props: true
  },
  {
    path: '/documentos/devolucao',
    name: 'devolution',
    component: Devolution,
    meta: { noAuth: true, noHeader: true },
    props: true
  },
  {
    path: '/documentos/extorno',
    name: 'chargeback',
    component: ChargeBack,
    meta: { noAuth: true, noHeader: true },
    props: true
  },
  {
    path: '/documentos/extrato',
    name: 'accountExtract',
    component: AccountExtract,
    meta: { noAuth: true, noHeader: true },
    props: true
  },
  // Erro
  {
    path: '/*',
    name: 'error404',
    component: Error404,
    meta: { noAuth: true, noHeader: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
